import { Observable } from "rxjs";
import { EntityId, UserId } from ".";

// abstract class, not interface to make it work nice with "provides" in app.module :-)
export abstract class AbstractPeopleService {
  public abstract GetPerson(login: EntityId): Observable<IPerson>;
  public abstract GetPersons(login: EntityId[]): Observable<IPerson[]>;
  public abstract SearchPeople(query: string): Observable<IPerson[]>;
}

export interface IPerson {
  id: UserId;
  displayName: string;
  imageSrc?: string;
  login: string;
  isAadGuest: boolean;
  email?: string;
}

export class PersonUtility {
  public static initials(person: IPerson): string {
    return ((person.displayName || "")
      .replace(/[^a-zA-Z- ]/g, "")
      .match(/\b\w/g)
      ?.join("") ?? "");
  }

  public static displayTitle(person: IPerson): string {
    return person.displayName + "<br>(" + (person.email || person.login) + ")";
  }
}
